var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-wrapper"},[_c('Header')],1),_c('div',{staticClass:"main",staticStyle:{"min-height":"100vh"}},[_c('router-view')],1),_c('foot-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }